export const isLinear = (p) => p?.pricing_mode === "linear_tiers" || p?.pricing_mode === "linear_material";

const limit = (t) => (t.up_to == null || t.up_to === "" ? Infinity : Number(t.up_to));
export const sortTiers = (tiers = []) => [...tiers].sort((a, b) => limit(a) - limit(b));

export const linearRate = (p, meters) => {
  if (p.pricing_mode === "linear_material") {
    const base = Number(p.material_cost_m || 0) + Number(p.labor_cost_m || 0);
    return base * (1 + Number(p.margin_pct || 0) / 100);
  }
  const tier = sortTiers(p.tiers).find((t) => t.up_to == null || t.up_to === "" || meters <= Number(t.up_to));
  return Number(tier?.price_per_m || 0);
};

export const calcLinear = (p, meters) => {
  const m = Number(meters) || 0;
  const rate = linearRate(p, m);
  const raw = rate * m;
  const min = Number(p.min_charge || 0);
  const total = Math.max(raw, min);
  return { meters: m, rate, raw, total: +total.toFixed(2), minApplied: min > raw, unitPrice: m > 0 ? total / m : 0 };
};

export const suggestedPrice = (p) => {
  const base = Number(p.cost_price || 0) + Number(p.freight_cost || 0) + Number(p.other_cost || 0);
  return +(base * (1 + Number(p.margin_pct || 0) / 100)).toFixed(2);
};
